import React from "react";

import { useTranslation } from "react-i18next";

import { AD_BREAK_TYPES } from "../../../constants/fast";
import prettyDurations, { DURATION_UNITS } from "../../../utils/durations";
import HeaderBlock from "../HeaderBlock";

import type { JSX } from "react";

import type { AdBreakListByType } from "../../../types/fast";

interface AdBreaksFormHeaderProps {
  adbreakListByType: AdBreakListByType;
}

export default function AdBreaksFormHeader({
  adbreakListByType,
}: AdBreaksFormHeaderProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");

  const { ADPODS, PRE_ADS_BUMPER, POST_ADS_BUMPER } = AD_BREAK_TYPES;

  const itemsNumber =
    adbreakListByType[ADPODS].mediaList.length +
    adbreakListByType[PRE_ADS_BUMPER].mediaList.length +
    adbreakListByType[POST_ADS_BUMPER].mediaList.length;

  const podDuration = adbreakListByType[ADPODS].duration;

  const totalDuration =
    adbreakListByType[ADPODS].duration +
    adbreakListByType[PRE_ADS_BUMPER].duration +
    adbreakListByType[POST_ADS_BUMPER].duration;

  return (
    <div className="flex flex-wrap gap-[0.78125rem]">
      <HeaderBlock blockList={[{ title: t("medias"), value: itemsNumber }]} />
      <HeaderBlock
        blockList={[
          {
            title: t("podDuration"),
            value:
              prettyDurations(podDuration, {
                valueUnit: DURATION_UNITS.MILLISECONDS,
              }).humanised || 0,
          },
        ]}
      />
      <HeaderBlock
        blockList={[
          {
            title: t("adBreaksDuration"),
            value:
              prettyDurations(totalDuration, {
                valueUnit: DURATION_UNITS.MILLISECONDS,
              }).humanised || 0,
          },
        ]}
      />
    </div>
  );
}
